import { useTranslation } from 'react-i18next';
import SpeechBubble from '../../FirstAid/components/SpeechBubble/SpeechBubble';
import mascot from '../../../assets/kitoBuddy/Kito-Asking-When-To-Worry 1.png';

export default function WhenToWorry({ title, disclaimer, options = [] }) {
  const { t } = useTranslation();
  return (
    <div>
      <SpeechBubble mascot={mascot} text={t(title)} bubbleoutline="#FF2B26" />
      <div className="when__content">
        <p>{t(disclaimer)}</p>
        <div className="when__options">
          <ul>
            {options.map((option) => (
              <li key={option}>{t(option)}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
